<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left">Data Address</h4>
      </div>
      <div class="col-12 col-md-6">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb float-right"
            style="background-color: transparent"
          >
            <li class="breadcrumb-item">
              <router-link to="/admin/dashboard">Dashboard</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Data Address
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button
          class="btn btn-primary float-right px-4 my-2"
          @click.prevent="addressForm"
        >
          Add Address
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <div class="d-flex justify-content-around" v-if="loading">
        <loader-component></loader-component>
      </div>

      <table class="table table-bordered table-hover" v-if="!loading">
        <thead class="thead-light">
          <tr>
            <th scope="col">No</th>
            <th scope="col">Title</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data.length == 0">
            <td colspan="7">Address is Empty</td>
          </tr>
          <tr v-for="(address, p) in data" :key="p">
            <th scope="row">{{ p + 1 }}</th>
            <td>{{ address.title }}</td>
            <td>
              <div class="d-flex justify-content-around">
                <!-- <p
                  style="cursor: pointer"
                  class="btn btn-link"
                  @click.prevent="editAddress(address.id)"
                >
                  <span class="material-icons"> launch </span>
                </p> -->
                <p
                  style="cursor: pointer"
                  class="btn btn-link"
                  @click.prevent="deleteAddress(address.id)"
                >
                  <span class="material-icons"> delete </span>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import LoaderComponent from "../../components/Loader.vue";
export default {
  name: "Address",
  components: { LoaderComponent },
  data() {
    return {
      loading: true,
      data: [],
    };
  },

  mounted() {
    this.getAllAddress();
  },

  methods: {
    getAllAddress() {
      this.loading = true;
      const endpoint = "warehouse-address";
      this.$api.get(endpoint, (status, data, message) => {
        if (status === 200) {
          this.loading = false;
          this.data = data.warehouse_address;
          console.log(this.data);
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    addressForm() {
      this.$router.push("/admin/address/add");
    },

    deleteAddress(id) {
      Vue.swal({
        title: "Are you sure?",
        text: "This banner will be delete",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Delete!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          const endpoint = `warehouse-address/${id}`;
          this.$api.delete(endpoint, (status, data, message) => {
            if (status === 200) {
              this.loading = false;
              Vue.swal("Success", "Address deleted", "success").then(() => {
                this.getAllAddress();
              });
            } else {
              this.loading = false;
              console.log(message);
            }
          });
        }
      });
    },

    editAddress(id) {
      this.$router.push(`/admin/address/edit/${id}`);
    },
  },
};
</script>
